export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/bicycles', 'admin.bicycles-list')
    .when('/admin/bicycles/:id', 'admin.bicycle-info')
    .when('/admin/bicycle-types', 'admin.bicycle-types')
    .when('/admin/bicycle-types/:id', 'admin.bicycle-type-info')
    .when('/admin/bicycle-brands', 'admin.bicycle-brands')
    .when('/admin/bicycle-parts', 'admin.bicycle-parts')

    .within('admin')

    .segment('bicycles-list', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.bicycles'
      }],
      template: '<admin-bicycles-list-page></admin-bicycles-list-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycles-list.module" */ "./list/admin-bicycles-list.module");
      }
    })
    .segment('bicycle-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.bicycles',
          url: '/admin/bicycles'
        },
        {
          label: 'admin.breadcrumb.bicycle_info'
        }
      ],
      template: '<admin-bicycle-info-page></admin-bicycle-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-info.module" */ "./info/admin-bicycle-info.module");
      }
    })
    .segment('bicycle-types', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.bicycles'
      }],
      template: '<admin-bicycle-types-page></admin-bicycle-types-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-groups.module" */ "./types/admin-bicycle-types.module");
      }
    })
    .segment('bicycle-type-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.bicycle_types',
          url: '/admin/bicycle-types'
        },
        {
          label: 'admin.breadcrumb.bicycle_type_info'
        }
      ],
      template: '<admin-bicycle-type-info-page></admin-bicycle-type-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-type-info.module" */ "./type-info/admin-bicycle-type-info.module");
      }
    })
    .segment('bicycle-brands', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.bicycles'
      }],
      template: '<admin-bicycle-brands-page></admin-bicycle-brands-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-brands.module" */ "./brands/admin-bicycle-brands.module");
      }
    })
    .segment('bicycle-parts', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [{
        label: 'admin.breadcrumb.bicycles'
      }],
      template: '<admin-bicycle-parts-page></admin-bicycle-parts-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-parts.module" */ "./parts/admin-bicycle-parts.module");
      }
    })
}
